import { useAuth } from '@/components/providers/AuthProvider';
import { getProfile } from '@/lib/actions/profile';
import { useQuery } from '@tanstack/react-query';

export const useProfileQuery = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['profile', user?.id],
    queryFn: () => getProfile({ withUserModel: true }),
    enabled: !!user?.id
  });
};
